// extracted by mini-css-extract-plugin
export default {"remove":"removableTag_remove__28duQ","removeIcon":"removableTag_removeIcon__nGq+N"};